import { render, staticRenderFns } from "./NumberDictionary.vue?vue&type=template&id=779b61be&"
import script from "./NumberDictionary.vue?vue&type=script&lang=js&"
export * from "./NumberDictionary.vue?vue&type=script&lang=js&"
import style0 from "./NumberDictionary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports